import {Component, OnInit, ViewChild} from '@angular/core';
import {FormService} from '../../../services/formServices';
import {Ticket} from '../../../domain/tickets';
import {DataTable, DataTableResource, DataTableTranslations} from 'angular5-data-table';
import {SessionService} from '../../../../core/services/sessionService';

@Component({
  selector: 'app-all-tickets-old',
  templateUrl: './all-tickets-old.component.html',
  styleUrls: ['./all-tickets-old.component.scss']
})
export class AllTicketsOldComponent implements OnInit {
    tickets: Array<Ticket>;
    ticketsResource: any;
    ticketsCount = 0;
    data: any;
    translations = <DataTableTranslations>{
        expandColumn: 'Expand column',
        selectColumn: 'Select column',
        paginationLimit: 'Max results',
        paginationRange: 'Result range'
    };
    @ViewChild(DataTable) filmsTable;
    constructor(private ticketService: FormService, private sessionService: SessionService) { }

    ngOnInit() {

        this.data = this.sessionService.getSession();
        this.sessionService.checkSessionState('admin');
        this.ticketService.getAllTickets2().subscribe(
            tickets => {
                this.tickets = tickets;
                this.ticketsResource = new DataTableResource(this.tickets);
                this.ticketsResource.count().then(count => this.ticketsCount = count);
            }
        );
        this.ticketsResource = new DataTableResource(this.tickets);
        this.ticketsResource.count().then(count => this.ticketsCount = count);
    }

    reloadItems(params) {
        this.ticketService.getAllTickets2().subscribe(
            tickets => this.tickets = tickets
        );
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.ticketsResource.filter = filterValue;
    }



}



// WEBPACK FOOTER //
// ./src/app/shared/modules/angular5-data-table/all-tickets-old/all-tickets-old.component.ts